import React, { Component } from 'react';
import classnames from 'classnames';
import scriptsSections from './content/scripts';
import './styles.css';

var topicMap = {
  scripts: scriptsSections,
};

function getLeafItems(sections) {
  var items = [];
  for (var i = 0; i < sections.length; i++) {
    var entry = sections[i];
    if (entry.children) {
      for (var j = 0; j < entry.children.length; j++) {
        items.push(entry.children[j]);
      }
    } else {
      items.push(entry);
    }
  }
  return items;
}

function findLeafById(sections, id) {
  var leaves = getLeafItems(sections);
  for (var i = 0; i < leaves.length; i++) {
    if (leaves[i].id === id) {
      return leaves[i];
    }
  }
  return null;
}

class HelpPane extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSection: null,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.activeTopic !== prevProps.activeTopic && this.props.activeTopic) {
      var leaves = getLeafItems(topicMap[this.props.activeTopic] || []);
      if (leaves.length > 0) {
        this.setState({ activeSection: leaves[0].id });
      }
    }
    if (this.props.isOpen && !prevProps.isOpen && !this.state.activeSection) {
      var leaves = getLeafItems(topicMap[this.props.activeTopic] || []);
      if (leaves.length > 0) {
        this.setState({ activeSection: leaves[0].id });
      }
    }
  }

  handleNavClick = (sectionId) => {
    this.setState({ activeSection: sectionId });
  };

  renderNavItems(sections) {
    var self = this;
    var activeSection = this.state.activeSection;
    var items = [];

    for (var i = 0; i < sections.length; i++) {
      var entry = sections[i];

      if (entry.children) {
        items.push(
          React.createElement('div', { key: entry.id, className: 'help-pane-nav-group-label' }, entry.title)
        );
        for (var j = 0; j < entry.children.length; j++) {
          var child = entry.children[j];
          items.push(
            React.createElement('button', {
              key: child.id,
              className: classnames('help-pane-nav-item', 'help-pane-nav-item-child', {
                'help-pane-nav-item-active': child.id === activeSection,
              }),
              onClick: (function (id) {
                return function () { self.handleNavClick(id); };
              })(child.id),
            }, child.title)
          );
        }
      } else {
        items.push(
          React.createElement('button', {
            key: entry.id,
            className: classnames('help-pane-nav-item', {
              'help-pane-nav-item-active': entry.id === activeSection,
            }),
            onClick: (function (id) {
              return function () { self.handleNavClick(id); };
            })(entry.id),
          }, entry.title)
        );
      }
    }

    return items;
  }

  render() {
    var props = this.props;
    var sections = topicMap[props.activeTopic] || [];
    var activeSection = this.state.activeSection;
    var activeContent = findLeafById(sections, activeSection);

    var topicTitle = 'Help';
    if (props.activeTopic === 'scripts') {
      topicTitle = 'Scripts Help';
    }

    return (
      <div className={classnames('help-pane', { 'help-pane-open': props.isOpen })}>
        <div className="help-pane-bar">
          <span className="help-pane-bar-title">{topicTitle}</span>
          <button className="help-pane-bar-close" onClick={props.onClose}>
            <span className="material-symbols-outlined">close</span>
          </button>
        </div>
        <div className="help-pane-body">
          <div className="help-pane-nav">
            {this.renderNavItems(sections)}
          </div>
          <div className="help-pane-content">
            {activeContent
              ? activeContent.body
              : React.createElement('p', { className: 'help-pane-empty' }, 'Select a topic from the sidebar.')
            }
          </div>
        </div>
      </div>
    );
  }
}

export default HelpPane;
